import { useQuery } from "@tanstack/react-query";

import type { NotificationType } from "~/shared/schemas/shipment-notification-schema.ts";
import { notificationTypeSchema } from "~/shared/schemas/shipment-notification-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import {
	getAndValidate,
	getAndValidateTraxAr,
} from "~/shared/services/api/fetch-client.ts";
import { getIsInternal } from "~/shared/utils/get-deployment-type.ts";

export const useNotificationTypes = () => {
	return useQuery<NotificationType[]>({
		queryKey: ["shipmentNotificationTypes"],
		queryFn: async (): Promise<NotificationType[]> => {
			const isInternal = getIsInternal();
			const route = isInternal
				? apiRoutes.SHIPMENTNOTIFICATIONTYPES
				: apiRoutes.EXTERNALSHIPMENTNOTIFICATIONTYPES;

			const result = isInternal
				? await getAndValidateTraxAr(route, notificationTypeSchema.array())
				: await getAndValidate(route, notificationTypeSchema.array());

			if (!result.success) {
				throw new Error(result.error);
			}

			return result.data;
		},
	});
};
